import { UniversalFilterConfig } from '../../components/Filters/ReportFilter';
import { REPORT_CODES, ReportCode } from './reportCodes';

// =========================
// 📦 INVENTARIO
// =========================
// import { inventoryInitialReportFilters } from './inventoryInitialReportFilters';
// import { inventoryStockReportFilters } from './inventoryStockReportFilters';
// import { inventoryMovementReportFilters } from './inventoryMovementReportFilters';
// import { inventoryAdjustmentReportFilters } from './inventoryAdjustmentReportFilters';
// import { kardexInventoryReportFilters } from './kardexInventoryReportFilters';

// =========================
// 🧾 PRODUCTOS
// =========================
import { productReportFilters } from './productReportFilters';
// import { topSellingProductsReportFilters } from './topSellingProductsReportFilters';
// import { grossProfitProductReportFilters } from './grossProfitProductReportFilters';
// import { salePricesReportFilters } from './salePricesReportFilters';

// =========================
// 👥 CLIENTES
// =========================
import { customerReportFilters } from './customerReportFilters';
import { salesByCustomerTotalReportFilters } from './salesByCustomerTotalReportFilters';
import { salesByCustomerProductReportFilters } from './salesByCustomerProductReportFilters';
import { inventoryInitialReportFilters } from './inventoryInitialReportFilters';
import { purchaseBySupplierSummaryReportFilters } from './purchaseBySupplierSummaryReportFilters';
import { excludedSubjectPurchaseReportFilters } from './excludedSubjectPurchaseReportFilters';
import { purchaseBySupplierProductReportFilters } from './purchaseBySupplierProductReportFilters';
import { inventoryStockReportFilters } from './inventoryStockReportFilters';
import { estadoCuentaClienteReportFilters } from './estadoCuentaClienteReportFilters';
import { finalConsumerAnnexReportFilters } from './finalConsumerAnnexReportFilters';
import { salesByBranchReportFilters } from './salesByBranchReportFilters';
import { salesByPaymentMethodReportFilters } from './salesByPaymentMethodReportFilters';
import { supplierReportFilters } from './supplierReportFilter';
import { inventoryMovementReportFilters } from './inventoryMovementReportFilters';
import { inventoryAdjustmentReportFilters } from './inventoryAdjustmentReportFilters';
import { kardexInventoryReportFilters } from './kardexInventoryReportFilters';
import { topSellingProductsReportFilters } from './topSellingProductsReportFilters';
import { frequentCustomerReportFilters } from './frequentCustomerReportFilters';
import { purchaseByPaymentMethodReportFilters } from './purchaseByPaymentMethodReportFilters';
import { reportXFilters } from './reportXFilters';
import { reportZFilters } from './reportZFilters';

// =========================
// 🧑‍💼 PROVEEDORES / COMPRAS
// =========================
// import { supplierReportFilters } from './supplierReportFilters';
// import { purchaseBySupplierSummaryReportFilters } from './purchaseBySupplierSummaryReportFilters';
// import { purchaseBySupplierProductReportFilters } from './purchaseBySupplierProductReportFilters';
// import { excludedSubjectPurchaseReportFilters } from './excludedSubjectPurchaseReportFilters';
// import { purchaseByPaymentMethodReportFilters } from './purchaseByPaymentMethodReportFilters';

// =========================
// 💰 VENTAS
// =========================
// import { salesByCustomerTotalReportFilters } from './salesByCustomerTotalReportFilters';
// import { salesByCustomerProductReportFilters } from './salesByCustomerProductReportFilters';
// import { salesByBranchReportFilters } from './salesByBranchReportFilters';
// import { salesByPaymentMethodReportFilters } from './salesByPaymentMethodReportFilters';
// import { costOfSalesReportFilters } from './costOfSalesReportFilters';

// =========================
// 🧾 FISCALES
// =========================
// import { reportXFilters } from './reportXFilters';
// import { reportZFilters } from './reportZFilters';

/**
 * 🗺️ Mapa central de filtros por código de reporte
 * Usa únicamente códigos oficiales (REPORT_CODES).
 * Es parcial: solo contiene los reportes cuya UI de filtros ya está lista
 * (los pendientes se resuelven como `[]` en ReportPage).
 */
export const reportFiltersMap: Partial<Record<ReportCode, UniversalFilterConfig[]>> = {
  // 📦 INVENTARIO
  [REPORT_CODES.INVENTARIO_INICIAL]: inventoryInitialReportFilters,
  [REPORT_CODES.EXISTENCIAS_INVENTARIO]: inventoryStockReportFilters,
  [REPORT_CODES.MOVIMIENTOS_INVENTARIO]: inventoryMovementReportFilters,
  [REPORT_CODES.AJUSTES_INVENTARIO]: inventoryAdjustmentReportFilters,
  [REPORT_CODES.KARDEX_INVENTARIOS]: kardexInventoryReportFilters,

  // 🧾 PRODUCTOS
  [REPORT_CODES.PRODUCTOS]: productReportFilters,
  [REPORT_CODES.PRODUCTOS_MAS_VENDIDOS]: topSellingProductsReportFilters,
  // [REPORT_CODES.UTILIDAD_BRUTA_PRODUCTOS]: grossProfitProductReportFilters,
  // [REPORT_CODES.PRECIOS_DE_VENTAS]: salePricesReportFilters,

  // 👥 CLIENTES
  [REPORT_CODES.CLIENTES]: customerReportFilters,
  [REPORT_CODES.CLIENTES_FRECUENTES]: frequentCustomerReportFilters,

  // 🧑‍💼 PROVEEDORES / COMPRAS
  [REPORT_CODES.PROVEEDORES]: supplierReportFilters,
  [REPORT_CODES.COMPRAS_PROVEEDOR_RESUMEN]: purchaseBySupplierSummaryReportFilters,
  [REPORT_CODES.COMPRAS_PROVEEDOR_PRODUCTOS]: purchaseBySupplierProductReportFilters,
  [REPORT_CODES.COMPRAS_SUJETO_EXCLUIDO]: excludedSubjectPurchaseReportFilters,
  [REPORT_CODES.COMPRAS_POR_FORMA_PAGO]: purchaseByPaymentMethodReportFilters,

  // 💰 VENTAS
  [REPORT_CODES.VENTAS_CLIENTES_TOTALES]: salesByCustomerTotalReportFilters,
  [REPORT_CODES.VENTAS_CLIENTES_PRODUCTOS]: salesByCustomerProductReportFilters,
  [REPORT_CODES.VENTAS_POR_SUCURSALES]: salesByBranchReportFilters,
  [REPORT_CODES.VENTAS_POR_FORMA_PAGO]: salesByPaymentMethodReportFilters,
  // [REPORT_CODES.COSTO_DE_VENTAS]: costOfSalesReportFilters,

  // 🧾 FISCALES
  [REPORT_CODES.ANEXO_CONSUMIDOR_FINAL]: finalConsumerAnnexReportFilters,
  [REPORT_CODES.REPORTE_X]: reportXFilters,
  [REPORT_CODES.REPORTE_Z]: reportZFilters,

  // 🏦 FINANZAS — CxC
  [REPORT_CODES.ESTADO_CUENTA_CLIENTE]: estadoCuentaClienteReportFilters,
};
